export default "__VITE_ASSET__oMddTy5u__"